import type { ReactNode } from 'react';
import { usePermission } from '@/shared/hooks/use-permission';

interface PermissionGateProps {
  permiso: string | string[];
  children: ReactNode;
  fallback?: ReactNode;
}

export function PermissionGate({ permiso, children, fallback = null }: PermissionGateProps) {
  const allowed = usePermission(permiso);
  return allowed ? <>{children}</> : <>{fallback}</>;
}
